import { Box, Grid } from '@material-ui/core'
import DepartmentModal from '../DepartmentModal'
import { QueueOptions } from '../QueueOptions'
import { useStyles } from './styles'

const QueueMenuTab = ({
  queueId,
  options,
  onAddOption,
  onUpdateOption,
  onDeleteOption,
  departmentModalOpen,
  setDepartmentModalOpen,
  selectedOptionForEdit,
  handleDepartmentSave
}) => {
  const classes = useStyles()
  return (
    <>
      <Grid container spacing={1} className={classes.contentTab}>
        <Grid item xs={12}>
          {/* Componente que renderiza a lista de opções interativas */}
          <QueueOptions
            queueId={queueId}
            options={options}
            onAddOption={onAddOption}
            onUpdateOption={onUpdateOption}
            onDeleteOption={onDeleteOption}
          />
        </Grid>
      </Grid>

      {/* Modal de Departamento integrado à lógica do Menu */}
      <DepartmentModal
        open={departmentModalOpen}
        onClose={() => setDepartmentModalOpen(false)}
        option={selectedOptionForEdit}
        onSaved={handleDepartmentSave}
        onFlowUpdate={() => {}}
      />
    </>
  )
}

export default QueueMenuTab
